// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"672f575b","328":"51f1a66f","388":"b7d864b0","404":"d8c79c93","612":"7a1c0f4f","632":"e97999f1","720":"f99925a9","780":"bd7b849a","836":"f8d659f6"}[chunkId] + ".chunk.js";
};